import { PendingDaysStatus } from '../types';

const MS_PER_DAY = 24 * 60 * 60 * 1000;

export function getDaysPending(registeredAt: string | null): number {
  if (!registeredAt) return 0;
  return Math.floor(
    (Date.now() - new Date(registeredAt).getTime()) / MS_PER_DAY
  );
}

export function getPendingDaysStatus(
  days: number,
  breakpoints: [number, number]
): PendingDaysStatus {
  if (days <= breakpoints[0]) return 'onTrack';
  if (days <= breakpoints[1]) return 'approaching';
  return 'overdue';
}
